export default "__VITE_PUBLIC_ASSET__ef52da5d__"